function SvgButton({x,y, width, height, bgColor, bgColor2, fontSize, title, disabled, onClick}) {
    
    return (<svg
        x={x??0}
        y={y}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        style={{ 
            cursor: 'pointer',
            outline: 'none',       // 移除默认轮廓
            outlineOffset: 0        // 清除轮廓偏移
        }} 
        role="button" // 增强可访问性
        tabIndex="0" // 使按钮可获得焦点
        onClick={(e) => { e.stopPropagation(); if (disabled) {return} onClick(); }}
    >
        <defs>
            {/* 渐变定义 */}
            <linearGradient
                id={`btnGradient-${bgColor.replace("#", "")}-${x}-${y}`}
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
            >
                <stop offset="0%" style={{ stopColor: (disabled?"#ccc":bgColor), stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: (disabled?"#ccc":(bgColor2??bgColor)), stopOpacity: 1 }} />
            </linearGradient>

            {/* 阴影滤镜 */}
            <filter
                id={`buttonShadow-${bgColor.replace("#", "")}-${x}-${y}`}
                x="-20%"
                y="-20%"
                width="140%"
                height="140%"
            >
                <feDropShadow
                    dx="2"
                    dy="2"
                    stdDeviation="3"
                    floodColor="rgba(0,0,0,0.4)"
                />
                <feDropShadow
                    dx="-2"
                    dy="-2"
                    stdDeviation="3"
                    floodColor="rgba(255,255,255,0.8)"
                />
            </filter>
        </defs>

        {/* 按钮主体 */}
        <rect
            x="10"
            y="10"
            width={width-20}
            height={height-20}
            rx="8"
            ry="8"
            fill={`url(#btnGradient-${bgColor.replace("#", "")}-${x}-${y})`}
            filter={`url(#buttonShadow-${bgColor.replace("#", "")}-${x}-${y})`}
        />

        {/* 按钮文字 */}
        <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            style={{
                fontFamily: 'Arial',
                fontSize: fontSize??14,
                fontWeight: 'bold',
                fill: (disabled?"#eee":'white'),
                userSelect: 'none' // 防止文字被选中
            }}
        >
            {title}
        </text>
    </svg>);
}

export default SvgButton